app.directive('visibleTags', [function(){
    return {
        restrict:'A',
        replace: false,
        transclude: false,
        scope: {

        },
        link: function(scope, element, attrs){

            var update = function(){
                console.log('update');
                var _this = element;

                if($(_this).position().top > $(_this).height()){
                    scope.$parent.client.visible = false;
                }else{
                    scope.$parent.client.visible = true;
                }

            };

            update();
            $(window).on('resize', update);
        }

    };
}]);
